<template>
    <app-layout>
        <common-page-plain>
            <common-content-spacer height="medium" :isCenter="true">
                <invites-member-form :inviteBy="inviteBy"></invites-member-form>
            </common-content-spacer>
        </common-page-plain>
    </app-layout>
</template>

<script>
    import AppLayout from 'components/layouts/AppLayout'
    import InvitesMemberForm from 'components/forms/admin/InvitesMemberForm'
    import InviteByEnum from '@/enums/InviteByEnum'

    export default {
        components: {
            AppLayout,
            InvitesMemberForm,
        },
        data() {
            return {
                inviteBy: InviteByEnum.INVITE_BY_EMAIL,
            }
        },
    }
</script>
